const MAX_FILE_SIZE = 20; // MB
const IMAGE_SELECTED = 0;
const ACCEPT_FILE_TYPE = ['image/jpeg', 'image/jpg', 'image/png'];
export default {
	IMAGE_SELECTED,
	MAX_FILE_SIZE,
	ACCEPT_FILE_TYPE,
};
